import { useCallback } from "react";
import { useClient } from "@app/portal-sdk";
import { formatDayAs } from "./format";

/**
 * POL-13: the client's own date display, for any screen inside a client portal.
 *
 * There was no helper that read the setting - `formatDay` has always formatted in
 * `en-US` whatever the client asked for - so this is the one the shell now has, and
 * every application can use it rather than formatting in six places.
 *
 *   const day = useDay();
 *   day(study.readoutOn)            // Nov 3, 2026   (or 2026-11-03 for an ISO client)
 *   day(study.readoutOn, "long")    // November 3, 2026
 *
 * Dates a person types stay `type="date"` and keep sending ISO. This is about reading.
 */
export const useDay = () => {
  const { client } = useClient();
  const dateDisplay = client.settings?.dateDisplay;
  return useCallback(
    (value: string | null | undefined, style: "medium" | "long" = "medium", fallback = "—") =>
      formatDayAs(dateDisplay, value, style, fallback),
    [dateDisplay]
  );
};
